module.exports = __webpack_public_path__ + "assets/landscape-icon-note.7f70e778.svg";